import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Stack,
  Typography,
  MenuItem,
  Grid,
  Divider,
  IconButton,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { Snackbar, Alert } from "@mui/material";
import { useAppointmentStore } from "../../stores/useAppointmentStore";
import DoctorsScheduleTable from "./DoctorsScheduleTable";
import axios from "axios";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const WorkingHoursForm = () => {
  let doctorUserId =
    sessionStorage.getItem("user") &&
    JSON.parse(sessionStorage.getItem("user")).user_id; // Replace with logged-in doctor ID
  const userName =
    sessionStorage.getItem("user") &&
    JSON.parse(sessionStorage.getItem("user")).username;
  console.log(sessionStorage.getItem("user"));
  console.log("Doctor ID:", doctorUserId);
  console.log("User Name:", userName);
  const doctorName =
    sessionStorage.getItem("user") &&
    `${JSON.parse(sessionStorage.getItem("user")).firstname} ${
      JSON.parse(sessionStorage.getItem("user")).lastname
    }`; // Replace with logged-in doctor Name
  const {
    workingHours,
    getWorkingHours,
    setWorkingHours,
    toastOpen,
    setToastOpen,
    setDoctorId,
    doctorId,
  } = useAppointmentStore();

  const [form, setForm] = useState({
    default_schedule: days.map((day) => ({
      day_of_week: day,
      first_half: { start: "", end: "" },
      break_time: { start: "", end: "" },
      second_half: { start: "", end: "" },
      slot_duration_minutes: 15,
      sameAsAbove: false,
      disabledFields: false,
      weekOffChecked: false,
    })),
    exceptions: [],
    holidays: [],
    week_off: [],
    applyMondayToRest: false,
  });

  const fetchDoctors = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev2/doctors`
      );
      const id = res.data.filter((doc) => doc.user_name === userName)[0].id;
      setDoctorId(id);
      console.log(id);
    } catch (err) {
      console.error(err);
      console.error("Failed to fetch doctors");
    }
  };

  useEffect(() => {
    if (userName) {
      fetchDoctors();
    }
  }, [userName]);

  useEffect(() => {
    getWorkingHours(doctorId);
  }, [doctorId]);

  useEffect(() => {
    if (workingHours) setForm({ ...form, ...workingHours });
  }, [workingHours]);

  // ==================== Handlers ====================

  // Handle input changes for schedule fields
  const handleScheduleChange = (day, fieldPath, value) => {
    setForm((prev) => ({
      ...prev,
      default_schedule: prev.default_schedule.map((d) =>
        d.day_of_week === day
          ? fieldPath.includes(".")
            ? {
                ...d,
                [fieldPath.split(".")[0]]: {
                  ...d[fieldPath.split(".")[0]],
                  [fieldPath.split(".")[1]]: value,
                },
              }
            : { ...d, [fieldPath]: value }
          : d
      ),
    }));
  };

  // Monday "Apply to rest of the days"
  const handleMondayCopy = (checked) => {
    const mondayData = form.default_schedule[0];
    setForm((prev) => ({
      ...prev,
      applyMondayToRest: checked,
      default_schedule: prev.default_schedule.map((d, i) => {
        if (i === 0) return { ...d }; // Monday itself
        return checked
          ? {
              ...d,
              first_half: { ...mondayData.first_half },
              break_time: { ...mondayData.break_time },
              second_half: { ...mondayData.second_half },
              slot_duration_minutes: mondayData.slot_duration_minutes,
              sameAsAbove: true,
              disabledFields: true,
              weekOffChecked: false,
            }
          : { ...d, sameAsAbove: false, disabledFields: false };
      }),
    }));
  };

  // "Same as above" for other days
  const handleSameAsAbove = (index, checked) => {
    setForm((prev) => {
      const updated = [...prev.default_schedule];
      if (checked) {
        const previous = updated[index - 1];
        updated[index] = {
          ...updated[index],
          first_half: { ...previous.first_half },
          break_time: { ...previous.break_time },
          second_half: { ...previous.second_half },
          slot_duration_minutes: previous.slot_duration_minutes,
          sameAsAbove: true,
          disabledFields: true,
          weekOffChecked: false,
        };
      } else {
        updated[index] = {
          ...updated[index],
          sameAsAbove: false,
          disabledFields: false,
        };
      }
      return { ...prev, default_schedule: updated };
    });
  };

  // Week Off toggle per day
  const handleWeekOffToggle = (day, checked) => {
    setForm((prev) => {
      let updatedWeekOff = [...prev.week_off];
      if (checked) {
        updatedWeekOff.push({ day_of_week: day });
      } else {
        updatedWeekOff = updatedWeekOff.filter((d) => d !== day);
      }

      const updatedSchedule = prev.default_schedule.map((d) =>
        d.day_of_week === day
          ? {
              ...d,
              first_half: checked ? { start: "", end: "" } : d.first_half,
              break_time: checked ? { start: "", end: "" } : d.break_time,
              second_half: checked ? { start: "", end: "" } : d.second_half,
              slot_duration_minutes: checked ? 15 : d.slot_duration_minutes,
              disabledFields: checked,
              weekOffChecked: checked,
            }
          : d
      );

      return {
        ...prev,
        default_schedule: updatedSchedule,
        week_off: updatedWeekOff,
      };
    });
  };

  // Holidays handlers
  const handleAddHoliday = () => {
    setForm((prev) => ({
      ...prev,
      holidays: [...prev.holidays, { date: "", reason: "" }],
    }));
  };
  const handleHolidayChange = (index, field, value) => {
    setForm((prev) => {
      const updated = [...prev.holidays];
      updated[index][field] = value;
      return { ...prev, holidays: updated };
    });
  };
  const handleDeleteHoliday = (index) => {
    setForm((prev) => {
      const updated = [...prev.holidays];
      updated.splice(index, 1);
      return { ...prev, holidays: updated };
    });
  };

  // Exceptions handlers
  const handleAddException = () => {
    setForm((prev) => ({
      ...prev,
      exceptions: [
        ...prev.exceptions,
        { date: "", availability_type: "", reason: "" },
      ],
    }));
  };
  const handleExceptionChange = (index, field, value) => {
    setForm((prev) => {
      const updated = [...prev.exceptions];
      updated[index][field] = value;
      return { ...prev, exceptions: updated };
    });
  };
  const handleDeleteException = (index) => {
    setForm((prev) => {
      const updated = [...prev.exceptions];
      updated.splice(index, 1);
      return { ...prev, exceptions: updated };
    });
  };

  // Submit
  const handleSubmit = () => {
    const payload = {
      ...form,
      default_schedule: form.default_schedule.map(
        ({ sameAsAbove, disabledFields, weekOffChecked, ...rest }) => rest
      ),
    };
    setWorkingHours(doctorName, payload);
  };
  console.log(toastOpen);
  // ==================== JSX ====================

  return (
    <Stack spacing={3} padding="16px">
      <Typography variant="h6">Doctor Weekly Schedule</Typography>
      {/* <DoctorsScheduleTable /> */}
      <Divider />
      <Typography variant="h6">Add/Update Weekly Schedule</Typography>
      {/* Weekly Schedule */}
      {form.default_schedule.map((dayItem, idx) => (
        <Stack
          key={dayItem.day_of_week}
          spacing={1}
          sx={{ border: "1px solid #eee", p: 2, borderRadius: 2 }}
        >
          <Typography variant="subtitle1">{dayItem.day_of_week}</Typography>

          {idx === 0 && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.applyMondayToRest}
                  onChange={(e) => handleMondayCopy(e.target.checked)}
                />
              }
              label="Apply Monday to rest of the days"
            />
          )}

          {idx !== 0 && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={dayItem.sameAsAbove}
                  disabled={false} // always clickable
                  onChange={(e) => handleSameAsAbove(idx, e.target.checked)}
                />
              }
              label="Same as above"
            />
          )}

          <FormControlLabel
            control={
              <Checkbox
                checked={dayItem.weekOffChecked}
                onChange={(e) =>
                  handleWeekOffToggle(dayItem.day_of_week, e.target.checked)
                }
              />
            }
            label="Week Off"
          />

          <Grid container spacing={2}>
            {["first_half", "break_time", "second_half"].map((period) => (
              <React.Fragment key={period}>
                <Grid item xs={6} sm={6}>
                  <TextField
                    label={`${period.replace("_", " ")} Start`}
                    type="time"
                    value={dayItem[period].start}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    disabled={
                      dayItem.sameAsAbove ||
                      dayItem.disabledFields ||
                      dayItem.weekOffChecked
                    }
                    onChange={(e) =>
                      handleScheduleChange(
                        dayItem.day_of_week,
                        `${period}.start`,
                        e.target.value
                      )
                    }
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <TextField
                    label={`${period.replace("_", " ")} End`}
                    type="time"
                    value={dayItem[period].end}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    disabled={
                      dayItem.sameAsAbove ||
                      dayItem.disabledFields ||
                      dayItem.weekOffChecked
                    }
                    onChange={(e) =>
                      handleScheduleChange(
                        dayItem.day_of_week,
                        `${period}.end`,
                        e.target.value
                      )
                    }
                  />
                </Grid>
              </React.Fragment>
            ))}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Slot Duration (minutes)"
                type="number"
                value={dayItem.slot_duration_minutes}
                fullWidth
                disabled={
                  dayItem.sameAsAbove ||
                  dayItem.disabledFields ||
                  dayItem.weekOffChecked
                }
                onChange={(e) =>
                  handleScheduleChange(
                    dayItem.day_of_week,
                    "slot_duration_minutes",
                    e.target.value
                  )
                }
              />
            </Grid>
          </Grid>
        </Stack>
      ))}

      <Divider />

      {/* Holidays Section */}
      <Typography variant="h6">Holidays</Typography>
      {form.holidays.map((h, index) => (
        <Stack
          key={index}
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ border: "1px solid #eee", p: 2, borderRadius: 2 }}
        >
          <TextField
            label="Date"
            type="date"
            value={h.date}
            onChange={(e) => handleHolidayChange(index, "date", e.target.value)}
          />
          <TextField
            label="Reason"
            value={h.reason}
            onChange={(e) =>
              handleHolidayChange(index, "reason", e.target.value)
            }
          />
          <IconButton onClick={() => handleDeleteHoliday(index)}>
            <Delete />
          </IconButton>
        </Stack>
      ))}
      <Button startIcon={<Add />} onClick={handleAddHoliday}>
        Add Holiday
      </Button>

      <Divider />

      {/* Exceptions Section */}
      <Typography variant="h6">Exceptions</Typography>
      {form.exceptions.map((ex, index) => (
        <Stack
          key={index}
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ border: "1px solid #eee", p: 2, borderRadius: 2 }}
        >
          <TextField
            label="Date"
            type="date"
            value={ex.date}
            onChange={(e) =>
              handleExceptionChange(index, "date", e.target.value)
            }
          />
          <TextField
            select
            label="Availability"
            value={ex.availability_type}
            onChange={(e) =>
              handleExceptionChange(index, "availability_type", e.target.value)
            }
          >
            <MenuItem value="first_half">First Half Only</MenuItem>
            <MenuItem value="second_half">Second Half Only</MenuItem>
            <MenuItem value="custom">Custom Timing</MenuItem>
            <MenuItem value="not_available">Not Available</MenuItem>
          </TextField>
          <TextField
            label="Reason"
            value={ex.reason}
            onChange={(e) =>
              handleExceptionChange(index, "reason", e.target.value)
            }
          />
          <IconButton onClick={() => handleDeleteException(index)}>
            <Delete />
          </IconButton>
        </Stack>
      ))}
      <Button startIcon={<Add />} onClick={handleAddException}>
        Add Exception
      </Button>

      <Divider />
      <Button variant="contained" onClick={handleSubmit}>
        Save Schedule
      </Button>
      <Snackbar
        open={toastOpen}
        autoHideDuration={3000}
        onClose={() => setToastOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setToastOpen(false)}
          severity="success"
          variant="filled"
        >
          Doctor schedule saved successfully!
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default WorkingHoursForm;
